/**
 * Renders a single collapsed left navigation rail item.
 * Owns presentational behavior only (icon/label/tooltip/active state) and emits selection events.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sb-left-nav-rail-item',
    templateUrl: './left-nav-rail-item.component.html',
    styleUrls: ['./left-nav-rail-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftNavRailItemComponent {
    @Input() label = '';
    @Input() tooltip = '';
    @Input() iconPath = '';
    @Input() isActive = false;
    @Input() ariaLabel = '';

    @Output() itemSelected = new EventEmitter<MouseEvent>();
    @Output() itemHovered = new EventEmitter<MouseEvent>();

    onSelect(event: MouseEvent): void {
        this.itemSelected.emit(event);
    }

    onHover(event: MouseEvent): void {
        this.itemHovered.emit(event);
    }
}
